import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/test',
    name: 'home',
    component: () => import('../views/Home/Home.vue'),
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('../views/Video/index.vue'),
  },
  {
    path: '/hello',
    name: 'hello',
    component: () => import('../views/Hello/Hello.vue'),
  },
  {
    path: '/training',
    name: 'another',
    component: () => import('../views/Another/Another.vue'),
  },
  {
    path: '/variants',
    name: 'variants',
    component: () => import('../views/Variants/Variants.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
